/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x279b=['RealTimeCollaborativeRevisionHistory','requires','pluginName'];(function(_0xad1715,_0x279bd8){var _0xde868b=function(_0x15c0c9){while(--_0x15c0c9){_0xad1715['push'](_0xad1715['shift']());}};_0xde868b(++_0x279bd8);}(_0x279b,0x91));var _0xde86=function(_0xad1715,_0x279bd8){_0xad1715=_0xad1715-0x0;var _0xde868b=_0x279b[_0xad1715];return _0xde868b;};import{Plugin as _0x51d6bf}from'ckeditor5/src/core';import _0xf30960 from'./realtimecollaborativerevisionhistory/cloudservicesrevisionhistoryadapter';import _0x2d46ff from'./realtimecollaborativeediting';export default class d extends _0x51d6bf{static get[_0xde86('0x0')](){return['RevisionHistory',_0xf30960,_0x2d46ff];}static get[_0xde86('0x1')](){return _0xde86('0x2');}}